import {
  Component,
  input,
  Type,
  ChangeDetectorRef,
  OnInit,
  DestroyRef,
  inject,
  ChangeDetectionStrategy,
} from "@angular/core";
import { DatabaseCacheService } from "../../../../data/cache/database-cache.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ExpertDialogInnerComponent } from "../../expert-dialog/expert-dialog-inner/expert-dialog-inner.component";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";
import { PopupWindowStateService } from "./popup-window-state.service";

@Component({
  selector: "app-popup-window",
  templateUrl: "./popup-window.component.html",
  styleUrls: ["./popup-window.component.scss"],
  imports: SHARED_IMPORTS,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopupWindowComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly databaseCashe = inject(DatabaseCacheService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  readonly popupWindowState = inject(PopupWindowStateService);

  readonly component = input<Type<unknown>>(ExpertDialogInnerComponent);
  readonly windowTitle = input($localize`:@@home.expertDialog.popup.windowTitle:連絡帳へ記入`);

  get isExpanded(): boolean {
    return this.popupWindowState.expanded();
  }

  isEnabled = false;

  showMentionMenu = false;
  selectedSectionGroupFunctions: string[] = [];

  ngOnInit(): void {
    this.databaseCashe.parametersUpdated.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this._initWindow();
      this.changeDetectorRef.markForCheck();
    });

    this._initWindow();
  }

  toggleWindow(): void {
    this.popupWindowState.toggleExpanded();
  }

  _initWindow() {
    const roles = this.databaseCashe.getSelectedSectionRoles();
    const hasRole = this._determineHasRoles(roles);

    this.selectedSectionGroupFunctions =
      this.databaseCashe.getSelectedSectionGroupFunctions();

    // selectedSectionGroupFunctions が配列であり、"Dialog" が含まれていれば showMentionMenu を true にする
    this.showMentionMenu =
      this.selectedSectionGroupFunctions &&
      Array.isArray(this.selectedSectionGroupFunctions) &&
      this.selectedSectionGroupFunctions.includes("Dialog");

    this.setEnabled(hasRole === true && this.showMentionMenu === true);
  }

  _determineHasRoles(roles: string[] | null | undefined) {
    let recordMeasurerRole = false;
    let recordRefererRole = false;

    if (roles != null && roles.length != 0) {
      if (roles.indexOf("MEASUREMENT") !== -1) {
        recordMeasurerRole = true;
      }

      if (roles.indexOf("REFER") !== -1) {
        recordRefererRole = true;
      }
    } else {
      console.warn(
        `[${ExpertDialogInnerComponent.name}] No roles for the  section`,
      );
    }

    return recordMeasurerRole || recordRefererRole;
  }

  private setEnabled(value: boolean): void {
    // Once enabled, never disable — prevents flickering during record navigation
    // which would destroy and recreate ExpertDialogInnerComponent
    if (this.isEnabled === value || (this.isEnabled && !value)) {
      return;
    }
    Promise.resolve().then(() => {
      this.isEnabled = value;
      this.changeDetectorRef.markForCheck();
    });
  }
}
